import { Navigate } from "react-router-dom";

export default function PublicRoute({ children }) {
  let token = localStorage.getItem("token");
  return token ? <Navigate to="/dashboard" /> : children;
}
